import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  skypointProjectLoading: false,
  skypointProject: [],
  skypointProjectCount: 0,
  skypointProjectTotalCount: 0,
  skypointProjectStatus: []
};

export const skypointProject = createSlice({
  name: "skypointProject",
  initialState,
  reducers: {
    setSkypointProjectLoading(state, action) {
      return {
        ...state,
        skypointProjectLoading: action?.payload,
      };
    },
    setSkypointProject(state, action) {
      return {
        ...state,
        skypointProjectLoading: false,
        skypointProject: action?.payload?.tasks,
        skypointProjectCount: action?.payload?.count,
        skypointProjectTotalCount: action?.payload?.totalCount,
      };
    },
    setSkypointProjectStatus(state, action) {
      return {
        ...state,
        skypointProjectStatus: action?.payload?.statuses,
      };
    },
  },
});

export const {
  setSkypointProjectLoading,
  setSkypointProject,
  setSkypointProjectStatus,
} = skypointProject.actions;
export default skypointProject.reducer;
